import React from 'react';
import { Input, Toggle } from 'rsuite';

// Receipt tagging, shared by the two places attachments are managed: the new
// expense form (files held locally until the expense exists) and the edit
// form's attachments panel (files already stored). Both ask the same question
// of every file and tally the answers against the amount requested, so the
// markup lives here rather than being written twice and drifting.

const formatCurrency = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '$0.00';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
};

// Not every attachment is a receipt — a mileage route screenshot isn't — so the
// question is per file, and the amount only matters once the answer is yes.
export function ReceiptTagFields({
  isReceipt,
  amountDisplay,
  onToggle,
  onAmountChange,
  onAmountBlur,
  disabled = false,
}) {
  return (
    <div className="d-flex align-items-center flex-wrap gap-2">
      <Toggle
        size="sm"
        checked={isReceipt}
        disabled={disabled}
        onChange={(checked) => onToggle?.(checked)}
      />
      <span style={{ fontSize: 13 }}>Is this attachment a receipt?</span>
      {isReceipt ? (
        <Input
          value={amountDisplay}
          onChange={(value) => onAmountChange?.(value)}
          onBlur={() => onAmountBlur?.()}
          placeholder="Receipt amount"
          size="sm"
          disabled={disabled}
          style={{ width: 150, marginLeft: 'auto' }}
        />
      ) : null}
    </div>
  );
}

// The running total of everything marked as a receipt, next to what the expense
// actually asks for. Only shown once something is marked, since there is
// nothing to reconcile before that.
export function ReceiptTotalsSummary({ receiptCount, receiptTotal, requestedAmount, matches, message }) {
  if (!receiptCount) return null;

  return (
    <div
      className="mt-2"
      style={{
        borderRadius: 8,
        padding: '10px 12px',
        border: `1px solid ${matches ? 'var(--dm-line-green, #a9d2b4)' : 'var(--dm-line-red, #f5c6c2)'}`,
        background: matches ? 'var(--dm-surface-low, #eef7f0)' : 'var(--dm-tint-red, #fef3f2)',
        color: matches ? 'var(--dm-text-green, #1c5b32)' : 'var(--dm-text-red, #b42318)',
      }}
    >
      <div className="d-flex justify-content-between">
        <span>
          Receipts total ({receiptCount} receipt{receiptCount === 1 ? '' : 's'})
        </span>
        <span style={{ fontWeight: 600 }}>{formatCurrency(receiptTotal)}</span>
      </div>
      <div className="d-flex justify-content-between">
        <span>Amount requested</span>
        <span style={{ fontWeight: 600 }}>{formatCurrency(requestedAmount)}</span>
      </div>
      <div className="mt-2" style={{ fontWeight: 600 }}>
        {message}
      </div>
    </div>
  );
}
